import React from 'react'
import ReactTooltip from 'react-tooltip'
import shortid from 'shortid'
import PropTypes from 'prop-types'

class Switch extends React.Component {
  constructor() {
    super()
    this.switchId = shortid.generate()
  }
  render() {
    const { onChange, on, className = '', tooltip } = this.props
    return (
      <button
        className={`switch ${on ? 'on' : 'off'} ${className}`}
        onClick={e => {
          onChange(!on, e)
        }}
        data-tip={tooltip}
        data-for={this.switchId}
        aria-label={`${tooltip} switch ${on ? 'on' : 'off'}`}
      >
        <div className="fob" />
        {tooltip && <ReactTooltip effect="solid" place="top" id={this.switchId} />}
      </button>
    )
  }
}
Switch.propTypes = {
  onChange: PropTypes.func.isRequired,
  on: PropTypes.bool.isRequired,
  className: PropTypes.string,
  tooltip: PropTypes.string,
  ariaLabel: PropTypes.string
}

export default Switch



// WEBPACK FOOTER //
// ./src/components/Shell/Switch.js